import * as React from "react";

import {Button, Modal} from "semantic-ui-react";
import {Icon} from "../../../icon/icon";

import "./popup-panel-action-oea.scss";
import {observer} from "mobx-react";
import {ActionButtonConfiguration} from "../../../../config/action-configuration";
import SVG from "react-inlinesvg";
import logo from "../../../../../assets/images/kt_logo_default.svg";

export interface PopupPanelActionOeaProps {
    actionConfig: ActionButtonConfiguration;
    buttonAsLink?: boolean;
    floated?: "left" | "right";
    graphic: __esri.Graphic;
    size?: "mini" | "tiny" | "small" | "medium" | "large" | "big" | "huge" | "massive";
}
@observer
export class PopupPanelActionOea extends React.Component<PopupPanelActionOeaProps, any> {

    constructor(props: PopupPanelActionOeaProps) {
        super(props);
        this.state = {
            open: false
        };
        this.setOpen = this.setOpen.bind(this);
    }
    setOpen(openFlag: boolean): void {
        this.setState({open: openFlag});
    }
    render(): React.ReactElement | null {
        const {actionConfig, buttonAsLink, floated, graphic, size} = this.props;
        if (!graphic) {
            return null;
        }
        const iFrameSrc = actionConfig.url +
        "grundbuch=" + (graphic.attributes.GBPER_CODE? graphic.attributes.GBPER_CODE: graphic.attributes.gbper_code) +
        ";grundstueckNummer=" + (graphic.attributes.NUMMER? graphic.attributes.NUMMER: graphic.attributes.nummer) +
        ";fromMap=true";
        return <Modal
            className={"geo-popup-action-modal"}
            centered={false}
            dimmer={"blurring"}
            open={this.state.open}
            onClose={() => this.setOpen(false)}
            onOpen={() => this.setOpen(true)}
            trigger={<Button
                compact
                floated={floated}
                size={size}
                className={
                    (actionConfig.className? actionConfig.className +" ": "")+(buttonAsLink? "geo-link-button":"")}>
                {actionConfig.icon && <Icon name={actionConfig.icon}/>} <span className={"action-title"}>
                    {actionConfig.title}</span></Button>}
        >
            <Modal.Header>
                <span className={"header__logo"}><SVG src={logo} height={27} width={84}/></span>
                <span className={"header__label-name"}>Grundbuch</span>
            </Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <iframe src={iFrameSrc} width={"100%"} height={"100%"}/>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={() => this.setOpen(false)} primary>
                    Schliessen
                </Button>
            </Modal.Actions>
        </Modal>;
    }
}
